import { createStore } from 'vuex'


// get JWT token here

export default createStore({
  state: {
    services : [],
    username : null,
    client : null,
    last_login : "",
    checker : false,
    ctoken: {},
  },
  getters: {
    services: state => {
      return state.services;
    },
    ctoken: state => {
      return state.ctoken
    },
    username : state => {
      return state.username
    },
    last_login : state => {
      return state.last_login
    },
    client : state => {
      return state.client
    },
    checker : state => {
      return state.checker
    }
  },
  mutations: {
    setServices(state, services){
      state.services = services
    },
    setCtoken(state, token){
      state.ctoken = token
    },
    setUsername(state, u){
      state.username = u
    },
    setLastLogin(state, u){
      state.last_login = u
    },
    setClient(state, c){
      state.client = c
    },
    setChecker(state, b){
      state.checker = b
    }
  },
  actions: {
    updateServices(state, payload){
      state.commit('setServices', payload)
    },
    updateToken(state, payload){
      state.commit('setCtoken', payload)
    },
    updateUsername(state, payload){
      state.commit('setUsername', payload)
    },
    updateLastLogin(state, payload){
      state.commit('setLastLogin', payload)
    },
    updateClient(state, payload){
      state.commit('setClient', payload)
    },
    updateCheckerStatus(state, b){
      state.commit('setChecker', b)
    }
  },
  modules: {
  }
})